
import React from "react";
import * as ReactRouterDom from "react-router-dom";
import { IGallery } from "../../../../../services";
import { i18nManager } from "../../../../../i18n";
import styles from "../../assets/style.module.css";
import { alertDialog, Classname, FileHelper, fileInputBuildFileInputPreview, FileInputPreviewType } from "@rivtn/noseur";

export interface GalleryItemProps {
    wide?: boolean;
    gallery: IGallery;
}

function GalleryItem({ gallery: g, wide }: GalleryItemProps) {

    const previewType = FileHelper.detectPreviewTypeFromUrl(g.media_location + (g.extra_data?.extension ?? ""));
    const isImage = previewType === FileInputPreviewType.IMAGE;

    const openPreview = () => {
        alertDialog({
            cancel: null,
            confirm: {
                label: i18nManager.Labels.gallery.close,
                props: {
                    textOnly: true,
                    style: { color: "var(--white)" }
                }
            },
            componentProps: {
                maximized: true,
                contentProps: {
                    style: { background: "var(--bg)" },
                }
            },
            message: fileInputBuildFileInputPreview({
                previewType,
                url: g.media_location,
                style: { margin: "auto" }
            })
        }).show();
    };

    return (<div className={Classname.build(styles["gal-item"], { [styles["gal-wide"]]: wide })}>
        {fileInputBuildFileInputPreview({
            previewType,
            url: g.media_location,
            style: { width: "100%", height: "100%" }
        })}
        {isImage && (<div className={styles["gal-veil"]} onClick={openPreview}>+</div>)}
        {(g.action_location || g.action_label) && (
            <ReactRouterDom.NavLink target="_blank" to={g.action_location} className={styles["gal-tag"]}>{g.action_label ?? g.extra_data?.tags?.join(", ")}</ReactRouterDom.NavLink>
        )}
    </div>);
}

export default GalleryItem;
